var map = {
	"./Terms.svg": 2275,
	"./Wireframe.svg": 5265,
	"./downloadBt.svg": 6616,
	"./image1.svg": 4619,
	"./image2.svg": 405,
	"./image3.svg": 1341,
	"./image4.svg": 5529,
	"./image5.svg": 7083,
	"./logo.png": 6949,
	"./top.svg": 1544
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7173;